<template>
  <FormulateInput
    v-bind="field"
    v-model="computedValue"
    :fullObject="fullObject"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Array],
    },
    fullObject: {
      type: [Object, Array],
    },
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue: {
      get: function () {
        if (this.value === '' || this.value === false) return null
        return this.value
      },
      set: function (newValue) {
        if (newValue === '' || newValue === false) {
          this.$emit('input', null)
          return
        }

        this.$emit('input', newValue)
      },
    },
  },
}
</script>
